import { bool, func, string } from 'prop-types'
import { Button, ButtonIconPosition, Icon, Tooltip } from '@opallabs/lapidary'
import { buttonCopy, popoverCopy, shouldDisableAdd } from './helpers'

import './styles.scss'

const AddItemButton = ({ addItem, disabled, theme, ...otherProps }) => {
  const phaseType = otherProps.phase_type
  const addDisabled = shouldDisableAdd(disabled, otherProps)

  const button = (
    <Button
      aria-disabled={addDisabled}
      icon={<Icon ariaHidden glyph="gem-add" />}
      iconPosition={ButtonIconPosition.trailing}
      buttonText={buttonCopy(phaseType)}
      name="add-phase"
      onClick={addDisabled ? undefined : addItem}
      variant="ghost"
      theme={theme}
      styleOverrides={addDisabled ? { button: { opacity: 0.5 } } : undefined}
    />
  )

  if (!otherProps.locked) {
    return button
  }

  return (
    <Tooltip
      size="small"
      type="description"
      text={popoverCopy(phaseType)}
      theme="light"
    >
      {button}
    </Tooltip>
  )
}

AddItemButton.propTypes = {
  addItem: func.isRequired,
  disabled: bool,
  theme: string,
}

export default AddItemButton
